// 处方路由
export default [{
    path: '/recipe/list',
    name: 'recipeList',
    component: () => import('@/views/recipe/list')
}, 
// 老版本迁移--我的处方
{
    path: '/myPrescription',
    name: 'myPrescription',
    component: () => import('@/views/recipe/list')
},
{
    path: '/recipe/detail/:id/:type?',
    name: 'recipeDetail',
    component: () => import('@/views/recipe/detail')
},{
    path: '/recipe/search',
    name: 'recipeSearch',
    component: () => import('@/views/recipe/search')
},
// 处方复购 - 复诊选择页（值班医生开场白 + 一致/不一致）
{
    path: '/recipe/repurchase/:id',
    name: 'recipeRepurchase',
    component: () => import('@/views/recipe/repurchaseChat')
},
// 处方复购 - IM 聊天页（连接 TIM，拉历史 + 实时消息，处方卡/服务包卡）
{
    path: '/recipe/repurchase/im/:consultId',
    name: 'recipeRepurchaseIm',
    component: () => import('@/views/recipe/repurchaseIm')
},
// 处方复购 - 确认订单（类似美团买药）
{
    path: '/recipe/repurchase/order/:id',
    name: 'recipeRepurchaseOrder',
    component: () => import('@/views/recipe/repurchaseOrder')
}]



// WEBPACK FOOTER //
// ./src/router/recipe.js